// extracted by mini-css-extract-plugin
export default {"section":"SeminarForm_section__+3Y3X","clearButton":"SeminarForm_clearButton__lvEFv"};